import * as React from "react";
import { useQuery } from "react-apollo";
import { RouteStore } from "bernie-core";
import { BlossomCustomerNotification, blossomCustomerNotificationQuery, ContextInput } from "__generated__/api";
import Customer = BlossomCustomerNotification.Customer;
import Links = BlossomCustomerNotification.Links;
import Actions = BlossomCustomerNotification.Actions;
import { gql } from "apollo-boost";
import { observer } from "mobx-react";
import {
  sendAnalytics,
  getLineOfBusiness,
  getFunnelLocation,
} from "components/shared/CustomerNotifications/NotificationsWithDialog/NotificationQueryUtils";
import { CustomTravelAdvisoryBanner } from "./CustomTravelAdvisoryBanner";
import { UitkSpacing } from "uitk-react-spacing";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

export interface CustomTravelAdvisoryProps {
  inputs: {
    context: ContextInput;
    lineOfBusiness: string;
    funnelLocation: string;
    location: string;
  };
  analyticsCallback: (rfrr: string, linkName: string | null) => void;
  className?: string;
  routeStore?: RouteStore;
}

const queryCustomerNotifications = gql`
  ${blossomCustomerNotificationQuery}
`;

export const CustomTravelAdvisory = observer((props: CustomTravelAdvisoryProps) => {
  const queryVariables = {
    context: props.inputs.context,
    notificationLocation: props.inputs.location,
    lineOfBusiness: getLineOfBusiness(props.inputs.lineOfBusiness),
    funnelLocation: getFunnelLocation(props.inputs.funnelLocation),
  };
  const { analyticsCallback, className = "" } = props;

  const { data, error, loading } = useQuery<{ customer: Customer }>(queryCustomerNotifications, {
    variables: queryVariables,
  });

  if (error || loading || !data || !data?.customer.notification || !data.customer.notification.body) {
    return null;
  }

  const { title, body, links } = data.customer.notification;

  const heading = title?.items[0].text;
  const message = body?.[0]?.items[0].text;

  const bannerLinks = links?.map(({ text, url, icon, actions }: Links) => ({ text, href: url, icon, actions }));
  const firstLink = bannerLinks?.shift();

  const onClickLink = (e: React.MouseEvent<HTMLElement>) => {
    sendAnalytics(firstLink!.actions as Actions[], analyticsCallback);
  };

  return (
    <>
      <Experiment name="April_Brand_Relaunch_Banner_US">
        <ExperimentControl />
        <ExperimentVariant bucket={1}>
          <UitkSpacing padding={{ blockstart: "six", inline: "six" }}>
            <div data-testid="custom-travel-advisory" data-stid="custom-travel-advisory" className={className}>
              <CustomTravelAdvisoryBanner
                heading={heading}
                message={message}
                linkText={firstLink?.text}
                onClickEvent={onClickLink}
                linkUrl={firstLink?.href}
              />
            </div>
          </UitkSpacing>
        </ExperimentVariant>
      </Experiment>
    </>
  );
});
